module.exports = {
	url: {
		api: `https://prodapi.getfitonline.nl`,
		login: `https://app.getfitonline.nl`,
		main: `https://app.getfitonline.nl`,
		cdn: `https://cdn.getfitonline.nl`,
	},
	cookiedomain: "getfitonline.nl",

	rules: {
		required: [(v) => !!v || 'Required field!'],
		name: [(v) => !!v || 'Required field!', (value) => (value && !(value.length > 100)) || 'Maximum 100 characters'],
		email: [(v) => !!v || 'E-mailadres is niet geldig!', (v) => /.+@.+\..+/.test(v) || 'Niet geldig e-mailadres!'],
		phonenumber: [(v) => !!v || 'Phone number is not valid!', (v) => /^[+]?[\s./0-9]*[(]?[0-9]{1,4}[)]?[-\s./0-9]*$/g.test(v) || 'Invalid phone number!'],

	},
	stripe: {
		intake_products: ["price_1O4N5lG2T5GDTYi2UydJEXr8", "price_1O4N7nG2T5GDTYi24ZFG6eMW"],
		extension_prices: ['price_1O4N8PG2T5GDTYi21GQAWKGG', 'price_1O4N9AG2T5GDTYi2Ov93RBs6'],

	},
	regex: {
		name: /^[a-zA-Z -]{2,50}$/,
		mail: /^.+@.+$/,
		phonenumber: /^\+?[1-9]\d{3,14}$/,
		password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d\s])[A-Za-z\d\S]{8,64}$/
	},
	cookies: {
		user: "user",
		refresh_token: "gfo_refresh_token",
		access_token: "gfo_access_token"

	},

	allowedredirectdomains: [
		'staging.getfitonline.nl',
		'getfitonline.nl',
		'localhost:8080',
		'localhost:8081',
		'localhost:8082',
		'localhost:8083',
		'localhost:8084',
		'localhost:8085',
		'localhost:8086',
	],
	dateformat: {
		weekday: 'short',
		year: 'numeric',
		day: 'numeric',
		month: 'long',
		hour: 'numeric',
		minute: 'numeric'
	}
}